import { type CSSProperties, Fragment, type ReactElement } from 'react';
import { classNames } from '@dimjs/utils';
import { isWindows } from '@flatbiz/utils';
import { DevFloatHelp } from '../../compts/dev-float-help/index.jsx';
// import { LeaveMenuDefault } from '../components/leave-menu';
// import { useLayoutCtx } from '../context/layout-ctx';
// import { layoutModels } from '../models';
import type { BootstrapOptions } from '../../types/layout.js';
import './style.less';

export const LayoutPage = (props: {
  style?: CSSProperties;
  children?: ReactElement;
  hideHeader?: boolean;
  elementId?: string;
  className?: string;
  showDevFloatHelp?: boolean;
  showProdEnvGuide: BootstrapOptions['showProdEnvGuide'];
  developmentEnvGuideConfigs: BootstrapOptions['developmentEnvGuideConfigs'];
}) => {
  // const LeaveMenuCompt = layoutCtx.LeaveMenu || LeaveMenuDefault;
  const isWin = isWindows();
  const className = classNames(
    'layout-page-wrapper',
    {
      'layout-page-noheader': props.hideHeader,
      'layout-page-windows': isWin,
    },
    props.className
  );

  return (
    <Fragment>
      {/* {state.leavebar.items?.length > 0 ? (
        <LeaveMenuCompt leaveMenus={state.leavebar.items} selectedKeys={state.leavebar.selectedKeys} />
      ) : null} */}
      <div className={className} id={props.elementId}>
        <div className="layout-page">{props.children}</div>
        {props.showDevFloatHelp ? (
          <DevFloatHelp
            developmentEnvGuideConfigs={props.developmentEnvGuideConfigs}
            showProdEnvGuide={props.showProdEnvGuide}
          />
        ) : null}
      </div>
    </Fragment>
  );
};
